import React, { Component } from "react";
import {  Alert } from "reactstrap";
class AlertMainPage extends Component {

  render() {

    return(
      <div>

      <Alert inline color="info" text-align="center">
      Requests expire after 3-4 days. Please support us <a href="https://www.patreon.com/examrescheduler" target="_blank" rel="noopener noreferrer">here</a> for requests that don't expire and other benefits!
      </Alert>
        

      </div>
    )
  }
}

export default AlertMainPage;